import { hookstate, useHookstate } from '@hookstate/core';
import { useEffect } from 'react';
import { inventoriesStatus, useConfig, useData } from '~/store/Query/api';

export const inventoryState = hookstate({});

export const inventoryModal = hookstate(false);

export const inventoryText = hookstate({
  product_stock_category_1_message: 'De momento no contamos con existencias en Tienda en Línea, pero muy pronto recibiremos más unidades, llena el siguiente formulario para',
  product_stock_category_1_link: 'avisarte la disponibilidad',
  product_modal_stock_category_title: 'Notificarme disponibilidad',
  product_modal_stock_category_description: 'Ingresa tus datos para notificarte cuando tengamos nuevamente más unidades disponibles',
  product_modal_stock_category_btnMesssage: 'Enviar',
  prooduct_modal_stock_success_category_title: '¡Hemos recibido tus datos!',
  prooduct_modal_stock_success_category_description: 'Estaremos enviándote un correo cuando tu producto se encuentre nuevamente disponible.',
  prooduct_modal_stock_success_category_btnMessage: 'Ir a tienda',
  prooduct_modal_stock_success_category_btnLink: '',
});

const useHabilitarLinks = () => useConfig('habilitar_links');

export const useInventoryText = () => {
  const config = useData(useHabilitarLinks);
  useEffect(() => {
    if (config) {
      inventoryText.merge(config.data.texto);
    }
  }, [config]);
  return useHookstate(inventoryText);
}

/**
 * Validate inventory for given items
 * @param items {Array<{ part_number: string, buyable: boolean }>}
 * @returns Promise<{ available: typeof items, unavailable: typeof items>}
 */
export async function validateInventory(items) {
  const res = await inventoriesStatus({ sku: items.map(item => item.part_number) });
  const available = [];
  let unavailable = [];
  if (res.ok) {
    for (const item of items) {
      if (item.buyable) {
        const quantity = res.body.inventory[item.part_number] ?? 0;
        inventoryState.nested(item.part_number).set(quantity);
        if (quantity > 0) {
          available.push(item);
          continue;
        }
      }
      unavailable.push(item);
    }
  } else {
    unavailable = items;
  }
  return {
    available,
    unavailable,
  };
}
